import en from "./en-us";
import zhcn from "./zh-cn";
import zhhk from "./zh-hk";
import vivn from "./vi-vn";

export default {
  "en-us": en,
  "zh-cn": zhcn,
  "zh-hk": zhhk,
  "vi-vn": vivn,
};
